import { FC, SVGProps } from "react";

const SessionsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.59766 4.50313C3.59766 2.68059 5.07512 1.20312 6.89766 1.20312H17.0977C18.9202 1.20312 20.3977 2.68059 20.3977 4.50313V19.5031C20.3977 21.3257 18.9202 22.8031 17.0977 22.8031H6.89766C5.07512 22.8031 3.59766 21.3257 3.59766 19.5031V4.50313ZM6.89766 3.00313C6.06923 3.00313 5.39766 3.6747 5.39766 4.50313V19.5031C5.39766 20.3316 6.06923 21.0031 6.89766 21.0031H17.0977C17.9261 21.0031 18.5977 20.3316 18.5977 19.5031V4.50313C18.5977 3.6747 17.9261 3.00313 17.0977 3.00313H6.89766ZM10.7977 18.3031C10.7977 17.8061 11.2006 17.4031 11.6977 17.4031H12.2977C12.7947 17.4031 13.1977 17.8061 13.1977 18.3031C13.1977 18.8002 12.7947 19.2031 12.2977 19.2031H11.6977C11.2006 19.2031 10.7977 18.8002 10.7977 18.3031Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.0977 5.20312C10.8215 5.20312 10.5977 5.42698 10.5977 5.70313V15.2031H13.5977V5.70312C13.5977 5.42698 13.3738 5.20312 13.0977 5.20312H11.0977ZM7.59766 8.70313C7.59766 8.42698 7.82151 8.20312 8.09766 8.20312H10.0977V15.2031H7.59766V8.70313ZM14.0977 10.7031H16.0977C16.3738 10.7031 16.5977 10.927 16.5977 11.2031V15.2031H14.0977V10.7031Z"
			fill="currentColor"
		/>
	</svg>
);

export { SessionsIcon };
